import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { collapseExpandSlow } from '../../animations/animations';

@Component({
  selector: 'rx-applications-collapse',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './collapse.component.html',
  styleUrls: ['./collapse.component.scss'],
  animations: [collapseExpandSlow]
})
export class CollapseComponent {
  @Input() isOpen = false

  toggle(isOpen?: boolean) {
    if (isOpen == undefined) {
      this.isOpen = !this.isOpen
    } else
      this.isOpen = isOpen
  }

  openOrClose(): 'open' | 'close' {
    return this.isOpen ? 'open' : 'close';
  }
}
